/**
 * Quais telas existem e onde cada uma mora.
 *
 * `lazy()` é o que faz a diferença de peso: o navegador baixa o pedaço
 * da tela no momento em que alguém entra nela. Quem só abre Indicadores
 * nunca baixa o código de Espaços, que é o mais pesado de todos (tem o
 * editor de polígono em cima do vídeo).
 *
 * As rotas com `:aba?` guardam a sub-aba no endereço. Isso não é enfeite
 * de URL: era estado só em memória, e atualizar a página devolvia o
 * cliente para a primeira aba, sempre.
 */

import { lazy, type ComponentType } from 'react'

export interface Rota {
  caminho: string
  Tela: ComponentType
}

export const ROTAS: Rota[] = [
  { caminho: '/inteligencia', Tela: lazy(() => tela('Inteligencia')) },
  { caminho: '/inteligencia/:aba', Tela: lazy(() => tela('Inteligencia')) },
  { caminho: '/avisos', Tela: lazy(() => tela('Avisos')) },
  { caminho: '/avisos/:aba', Tela: lazy(() => tela('Avisos')) },
  { caminho: '/indicadores', Tela: lazy(() => tela('Indicadores')) },
  { caminho: '/relatorios', Tela: lazy(() => tela('Relatorios')) },
  { caminho: '/busca', Tela: lazy(() => tela('Busca')) },
  { caminho: '/busca/:aba', Tela: lazy(() => tela('Busca')) },
  { caminho: '/eventos', Tela: lazy(() => tela('Eventos')) },
  { caminho: '/jornadas', Tela: lazy(() => tela('Jornadas')) },
  { caminho: '/circulacao', Tela: lazy(() => tela('Circulacao')) },
  { caminho: '/eventos/:aba', Tela: lazy(() => tela('Eventos')) },
  { caminho: '/cameras', Tela: lazy(() => tela('Cameras')) },
  { caminho: '/cameras/:aba', Tela: lazy(() => tela('Cameras')) },
  { caminho: '/pessoas', Tela: lazy(() => tela('Pessoas')) },
  { caminho: '/espacos', Tela: lazy(() => tela('Espacos')) },
  { caminho: '/calibrar/:a/:b', Tela: lazy(() => tela('Calibrar')) },
  { caminho: '/automacoes', Tela: lazy(() => tela('Automacoes')) },
  { caminho: '/filiais', Tela: lazy(() => tela('Filiais')) },
  { caminho: '/config', Tela: lazy(() => tela('Config')) },
  { caminho: '/config/:aba', Tela: lazy(() => tela('Config')) },
]

/**
 * O import dinâmico, num lugar só.
 *
 * O caminho precisa ser literal o bastante para o empacotador enxergar —
 * por isso o `./telas/${nome}` com a extensão explícita, e não uma
 * variável solta. Cada arquivo exporta `Tela` como exportação padrão.
 */
function tela(nome: string): Promise<{ default: ComponentType }> {
  return import(`./telas/${nome}.tsx`) as Promise<{ default: ComponentType }>
}
